import React, { useState, useRef, useEffect } from 'react';

function ChatInterface({ chatHistory, onSendQuery, loading }) {
  const [query, setQuery] = useState('');
  const chatContainerRef = useRef(null);
  
  // Scroll to bottom of chat when new messages arrive
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!query.trim() || loading) return;
    
    onSendQuery(query);
    setQuery('');
  };
  
  return (
    <div className="chat-interface">
      <div className="chat-header">
        <h3>Chat Assistant</h3>
      </div>
      
      <div className="chat-messages" ref={chatContainerRef}>
        {chatHistory.length === 0 ? (
          <div className="empty-chat">
            <p>Ask me about reach curves, audience targeting, or how to use this tool.</p>
            <p>Examples:</p>
            <ul>
              <li>"Compare the current scenario with Scenario 2"</li>
              <li>"What happens if I increase the budget by 20%?"</li>
              <li>"Which channel gives the best reach efficiency?"</li>
              <li>"Create a scenario targeting millennials with a $150k budget"</li>
            </ul>
          </div>
        ) : (
          chatHistory.map((message, index) => (
            <div key={index} className={`chat-message ${message.type}`}>
              <div className="message-avatar">
                {message.type === 'user' ? '👤' : message.type === 'agent' ? '🤖' : 'ℹ️'}
              </div>
              <div className="message-content">
                {message.content}
              </div>
            </div>
          ))
        )}
        
        {loading && (
          <div className="chat-message agent loading">
            <div className="message-avatar">🤖</div>
            <div className="message-content">
              <div className="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <form className="chat-input-container" onSubmit={handleSubmit}>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Ask about reach, channels, or scenarios..."
          disabled={loading}
        />
        <button type="submit" disabled={loading}>
          {loading ? '...' : 'Send'}
        </button>
      </form>
    </div>
  );
}

export default ChatInterface;